import { objectIsEmpty } from '@widergy/web-utils/lib/object';
import { isEmpty } from '@widergy/web-utils/lib/array';

export const getAvailableSlots = daySlots => daySlots.filter(item => item.available);

export const hasAvailableSlots = day =>
  !objectIsEmpty(day) && day.working_day_slots && !isEmpty(getAvailableSlots(day.working_day_slots));
